import {
  BanknoteArrowUp,
  MessageCircleQuestionMark,
  ScanBarcode,
} from "lucide-react";
import type { SVGProps } from "react";

export type LucideIconName =
  | "banknote-arrow-up"
  | "scan-barcode"
  | "message-circle-question-mark";

export type LucideIconProps = {
  name: LucideIconName;
} & SVGProps<SVGSVGElement>;

export const LucideIcon = ({ name, ...props }: LucideIconProps) => {
  const renderIcon = () => {
    switch (name) {
      case "banknote-arrow-up":
        return <BanknoteArrowUp {...props} />;
      case "scan-barcode":
        return <ScanBarcode {...props} />;
      case "message-circle-question-mark":
        return <MessageCircleQuestionMark {...props} />;
    }
  };

  return renderIcon();
};
